import gql from 'graphql-tag';

const IMPORT_DOCUMENT_TEMPLATES_FROM_LIBRARY_MUTATION = gql`
  mutation importDocumentTemplatesFromLibrary($input: [DocumentTemplateImportInput]) {
    importDocumentTemplatesFromLibrary(input: $input)
  }
`;

export default IMPORT_DOCUMENT_TEMPLATES_FROM_LIBRARY_MUTATION;
